import React from 'react';

import { observer } from 'mobx-react';

import { loggedInUserDataStore } from '../../../../shared/stores/loggedInUserDataStore';
// Hidden per LMP-5588
// import { NgzNotificationsSettings } from '../../../../guides-and-additional-info/containers/NgzNotificationsSettings/NgzNotificationsSettings';
import { CoachPasswordBlock } from '../../../../auth-management/components/CoachPasswordBlock/CoachPasswordBlock';

const CoachSystemSettingsTab = observer(() => {
  const { loggedInUser } = loggedInUserDataStore;
  const userId = loggedInUser!.id as number;
  const userEmail = loggedInUser!.email;

  return (
    <div>
      <CoachPasswordBlock userId={userId} userEmail={userEmail} />
      {/* Hidden per LMP-5588: <NgzNotificationsSettings /> */}
    </div>
  );
});

export { CoachSystemSettingsTab };
